export const EDITABLE_SET = 'at/licenses/creditCard/EDITABLE_SET'
export const IS_ADDRESS_FORM_OPEN_SET = 'at/licenses/creditCard/IS_ADDRESS_FORM_OPEN_SET'
export const CARD_FIELDS_CHANGE = 'at/licenses/creditCard/CARD_FIELDS_CHANGE'
export const BILLING_ADDRESS_SET = 'at/licenses/creditCard/BILLING_ADDRESS_SET'
export const CARD_INFO_SET = 'at/licenses/creditCard/CARD_INFO_SET'
export const STRIPE_FIELDS_VALID_SET = 'at/licenses/creditCard/STRIPE_FIELDS_VALID_SET'
export const NEED_SAVE_CARD_SET = 'at/licenses/creditCard/NEED_SAVE_CARD_SET'


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/actionTypes.js